module.exports = __webpack_public_path__ + "img/compact.6bbd0492.png";